import React, { Component } from 'react';
import Styles from '../Styles.js';
import { GlobalContext } from '../global-context';

export default class SideNav extends Component {
  static contextType = GlobalContext;

  render() {
    const { navigate } = this.props;
    const { config, person, updateUserQuery } = this.context;
    const projects = person.projects;

    return (
      <div style={{backgroundColor: "#232D4B", height: "100%", minHeight:"100vh", padding: "20px"}}>
        <Styles>
          <div onClick={() => navigate(``)} key="home">
            <h2 style={{cursor: "pointer", marginBottom: "20px", color: "#fff", letterSpacing: "1px"}}>Home</h2>
          </div>
          {person.roles && person.roles.length > 0 && <div onClick={() => {
            updateUserQuery(null);
            navigate("projects");
          }}>
            <h2 style={{cursor: "pointer", marginBottom: "20px", color: "#fff"}}>All Projects</h2>
          </div>}
          {
            projects && projects.length ? projects.map((project) => {
              let status = config.project_states[project.project_state ? project.project_state : 0]
              let prjtext = `${project.role}: ${project.title}`
              let stattext = `(State: ${status})`
              return (
                <div onClick={() => navigate(`project/${project.id}`)} key={project.title}>
                  <h3 style={{cursor: "pointer", marginBottom: "2px", color: "#fff"}}>{prjtext}</h3>
                  <p style={{cursor: "pointer", marginBottom: "20px", color: "#fff"}}>{stattext}</p>
                </div>
              );
            }) : null
          }
        </Styles>
      </div>
    );
  }
}
